import { useGlobalState } from '@highlight/ipc/react'
import type { OverlayDisplayDockInsets } from '@shared/types/display.ts'
import { isMac } from '@shared/utils/platform.ts'

/**
 * Dock/menu reservation for the display Electron associates with the fullscreen overlay,
 * from `bounds` vs `workArea` (published in main via {@link computeOverlayDisplayDockInsets}).
 */
export function useOverlayDisplayDockInsets(): OverlayDisplayDockInsets | undefined {
  const [insets] = useGlobalState<OverlayDisplayDockInsets | undefined>('macOS.overlayDisplayDockInsets')
  if (!isMac) {
    return undefined
  }
  return insets
}
